var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_189_4519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 7.7037H6.85714V16H4V7.7037ZM16 16H8V7.22785L9.73829 4.52385L10.2211 1.01748C10.2612 0.735475 10.3975 0.47772 10.6052 0.291023C10.8129 0.104326 11.0783 0.00106815 11.3531 0H11.4286C11.8831 0.000470646 12.3189 0.187923 12.6403 0.521219C12.9616 0.854515 13.1424 1.30643 13.1429 1.77778V5.33333H17.7143C18.3203 5.33412 18.9012 5.5841 19.3297 6.02847C19.7582 6.47283 19.9992 7.07528 20 7.7037V11.8519C19.9988 12.9516 19.577 14.006 18.8271 14.7836C18.0772 15.5613 17.0605 15.9987 16 16Z",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1429 5.58333H17.714C18.2508 5.58403 18.7673 5.80539 19.1497 6.202C19.5325 6.59891 19.7493 7.13891 19.75 7.704V11.8516C19.7489 12.888 19.3513 13.8799 18.6471 14.6101C17.9433 15.34 16.991 15.7488 15.9997 15.75H8.25V7.30128L9.94858 4.65904L9.97842 4.61262L9.98595 4.55796L10.4687 1.05265C10.4687 1.05248 10.4687 1.05232 10.4687 1.05216C10.5008 0.827219 10.6093 0.623446 10.7723 0.476954C10.9351 0.330661 11.1414 0.250938 11.3537 0.25H11.4284C11.8137 0.250433 12.185 0.409258 12.4603 0.694753C12.7359 0.980586 12.8925 1.37002 12.8929 1.77802V5.33333V5.58333H13.1429ZM4.25 7.9537H6.60714V15.75H4.25V7.9537Z",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_189_4519",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_189_4519"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_189_4519",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyLike);
export default __webpack_public_path__ + "static/media/grey-like.b03a57bd82e6d6874ec5d00a54f99a39.svg";
export { ForwardRef as ReactComponent };